var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoGuiaCae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 32",
    style: {
      enableBackground: "new 0 0 33 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 228,
    height: 230,
    xlinkHref: "414513D1.jpg",
    transform: "matrix(1 0 0 1 340.5419 -73.5)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,27.7H3.3c-0.9,0-1.6-0.7-1.6-1.6V2.9c0-0.9,0.7-1.6,1.6-1.6h7.5c2.3,0,4.2,1.9,4.2,4.2V27.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,27.7h11.7c0.9,0,1.6-0.7,1.6-1.6V2.9c0-0.9-0.7-1.6-1.6-1.6h-7.5c-2.3,0-4.2,1.9-4.2,4.2V27.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27.7,
    className: "st0",
    width: 3,
    height: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoGuiaCae);
export default __webpack_public_path__ + "static/media/icono-guia-cae.3c2a0090fcdcabeb55e08a2ff045c556.svg";
export { ForwardRef as ReactComponent };